module.exports = __webpack_public_path__ + "static/img/15.e55293c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/15.png
// module id = ffzX
// module chunks = 1